import { freezeRequest } from './generation-request.js';

/** Preserve reviewed render inputs while identifying this submission attempt. */
export function createImageAttemptRequest(request, attemptId) {
  return freezeRequest({ ...request, slots: request.slots.map((slot) => ({
    ...slot,
    projectConfig: { ...slot.projectConfig, attribution: {
      ...slot.projectConfig.attribution,
      rootOperationId: request.id,
      parentOperationId: `${slot.id}:${attemptId}`
    } }
  })) });
}
